import styled from "styled-components";
import { useState } from "react";

// Components
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import CommonButton from "../../../../components/common/CommonButton";
import StudentsAssignedModal from "./StudentsAssignedModal";
import SuccessAssignedModal from "./SuccessAssignedModal";
import ChartResultsModal from "./ResultsChartModal";
import AssignModal from "./AssignModal";
import { Icon } from "@iconify/react";

const ManagementCard = (props) => {

    const { simulator, users } = props;

    const [isChartResultsModalOpen, setIsChartResultsModalOpen] = useState(false);
    const [isAssignmentsModalOpen, setIsAssignmentsModalOpen] = useState(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isSuccessAssignedModalOpen, setIsSuccessAssignedModalOpen] = useState(false);

    const handleViewChartFromAnalysis = () => {
        setIsChartResultsModalOpen(true);
    };

    const handleViewAssignments = () => {
        setIsAssignmentsModalOpen(true);
    };

    const handleAssign = () => {
        setIsAssignModalOpen(true);
    };

    console.info("SIMULATOR CARD", simulator)

    return (
        <Wrapper>
            <Container>
                <LeftInfo>
                    <Icon icon="nimbus:rocket" size={24} />
                    <section>
                        <label>SIMULADOR {simulator?.category?.toUpperCase()}</label>
                        <p>"{simulator?.name}"</p>
                    </section>
                </LeftInfo>
                <RightInfo>
                    <span>
                        {
                            
                                (simulator?.run_codes?.length > 0 &&
                                simulator?.run_codes?.some(runCode => runCode?.sessions?.length > 0))
                                && (
                                <>
                                    <CommonButton
                                        variant="filled"
                                        onClick={handleViewChartFromAnalysis}
                                        Icon={() => (<div><FontAwesomeIcon icon="fa-light fa-chart-radar" size={24} /></div>)}
                                        disabled={true}
                                    />
                                    <CommonButton
                                        label={`Ver asignaciones (${simulator?.run_codes?.reduce((total, runCode) => total + (runCode?.sessions?.length || 0), 0)})`}
                                        variant="outlined"
                                        onClick={handleViewAssignments}
                                    />
                                </>
                            )
                        }
                        <CommonButton
                            label="Asignar"
                            variant="filled"
                            onClick={handleAssign}
                            Icon={() => (<div> <FontAwesomeIcon icon="fa-regular fa-plus" size={24} /></div>)}
                        />
                    </span>
                    <ChartResultsModal
                        isOpen={isChartResultsModalOpen}
                        onClose={() => setIsChartResultsModalOpen(false)}
                        attributes={simulator?.attributes}
                    />
                    <StudentsAssignedModal
                        isOpen={isAssignmentsModalOpen}
                        onClose={() => setIsAssignmentsModalOpen(false)}
                        simulator={simulator}
                    />
                    <AssignModal
                        isOpen={isAssignModalOpen}
                        onClose={(succeed) => {
                            setIsAssignModalOpen(false)
                            if (succeed) {
                                setIsSuccessAssignedModalOpen(true)
                            }
                        }}
                        users={users}
                        simulator={simulator}
                    />
                    <SuccessAssignedModal
                        isOpen={isSuccessAssignedModalOpen}
                        onClose={() => setIsSuccessAssignedModalOpen(false)}
                    />
                </RightInfo>
            </Container>
        </Wrapper>
    )
}

export default ManagementCard;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 1rem;
`;

const StateWrapper = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    svg {
        color: ${props => props.state === "disponible" ? "#28A986" : "#C29F43"};
    }

    span {
        font-size: 16px;
        font-weight: 600;
        color: ${props => props.state === "disponible" ? "#28A986" : "#C29F43"};
    }
`;

const Container = styled.div`
    width: 100%;
    height: 100px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0px 8px 24px -4px #18274B14, 0px 6px 12px -6px #18274B1F;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const LeftInfo = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 2rem;
    padding-left: 3rem;

    svg {
        width: 24px;
        height: 24px;
        color: #b31d15;
    }

    section {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 0.5rem;

        p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        label {
            color: #b31d15;
        }
    }
`

const RightInfo = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 2rem;

    span {
        display: flex;
        align-items: center;
        gap: 1rem;

        label {
            font-weight: 400;
            font-size: 14px;
            color: #535353;
        }

        section {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #b31d15;
            font-size: 20px;

            p {
                width: 2rem;
                text-align: center;
            }
        }
    }
`